"use client";

import { useEffect, useState } from "react";
import { toolLoadNavPrefetchMode } from "@/lib/performance/tool-load-timing";

export function useToolLoadNavPrefetchAttestation(prefetch: boolean | undefined) {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated ? toolLoadNavPrefetchMode(prefetch) : "default";
}
